import { Avatar, Button, Container, CssBaseline, makeStyles, TextField, Typography } from '@material-ui/core';
import React, { useContext, useEffect ,useState } from 'react'
import { Redirect } from 'react-router-dom';

import FaceIcon from '@material-ui/icons/Face';

import { firebaseAuth } from './AuthProvider';

import logo from '../../images/logo.png'

function AdminLogIn() {

  const {handleSignin, inputs, setInputs,token, errors} = useContext(firebaseAuth)

    const handleSubmit = (e) => {
      e.preventDefault()
      const email = e.target.email.value
      const pass = e.target.password.value
      const sendState = {email: email, password: pass}
      setInputs(sendState)
      handleSignin(sendState)
      
    }

  
    
   
    const useStyles = makeStyles((theme) => ({
      paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
      },
      form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
      },
      submit: {
        margin: theme.spacing(3, 0, 2),
      },
    }));

    const classes = useStyles();


    if(token!==null){
      return  <Redirect to ={{pathname:"/admin"}}/>
    }

    return (
     
      <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
       
            <img src={logo} style={{maxWidth:"50px"}}/>
      
        <Typography component="h1" variant="h5">
          Admin Prijava
        </Typography>

        <form onSubmit={handleSubmit} className={classes.form}>
        {/* replace the div tags with a form tag */}
      
        {/* make inputs  */}
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            type="email"
            autoFocus
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="pass"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
           
          />

        {/* TODO FIX THIS  */}
        {/* <input  name="email" placeholder='email' type="email"  required/>
        <input  name="password" placeholder='password' type="text" required /> */}
  

           <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            style={{backgroundColor:"#45B283"}}
            className={classes.submit}
          >
            Prijavi se
          </Button>
        {/* <button>signin</button> */}
        {errors.length > 0 ? errors.map(error => <p style={{color: 'red'}}>{error}</p> ) : null}


      </form>
      </div>
      </Container>

    )
}

export default AdminLogIn
